import { BaseWebComponentDataProviderFactory } from './BaseWebComponentDataProviderFactory';
import { BaseWebComponentDataProvider } from './BaseWebComponentDataProvider';

interface IInitialSetup {
  dataProviderFactory: BaseWebComponentDataProviderFactory;
}

export class BaseWebComponentRepository {
  public dependenciesInjected: boolean;
  public dependencies: any;
  public dataProviderFactory: BaseWebComponentDataProviderFactory;
  public dataProvider: BaseWebComponentDataProvider;

  initialSetup({ dataProviderFactory }: IInitialSetup) {
    this.dependenciesInjected = false;
    this.dependencies = {};

    this.dataProviderFactory = dataProviderFactory;
  }

  injectDependencies(dependencies: any) {
    this.dependencies = dependencies;
    this.build();
    this.dependenciesInjected = true;
  }

  build<T extends BaseWebComponentDataProvider>() {
    this.buildDataProvider<T>();
  }

  buildDataProvider<T extends BaseWebComponentDataProvider>() {
    if (!this.dataProviderFactory) {
      throw new Error('Data provider factory not defined');
    }
    this.dataProvider = this.dataProviderFactory.build<T>(this.dependencies.api.type);
    this.dataProvider.injectDependencies(this.dependencies);
  }
}
